<template>
  <div class="reappro__header" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
    <backlink class="white"/>
    <div class="reappro__header-title-container">
      <img v-if="recept == true" src="/static/img/pictos/reapproValide.svg" class="">
      <img v-else-if="list == true || detail == true" src="/static/img/pictos/reappro.svg" class="">
      <img v-else src="/static/img/pictos/reapproParametres.svg" class="">
      <span v-if="next == true">Mon prochain reappro</span>
      <span v-else-if="recept == true">Je réceptionne mon reappro</span>
      <span v-else-if="list == true">Mes réappros</span>
      <span v-else-if="detail == true">Mon réappro</span>
      <span v-else>Je paramètre mon reappro</span>
    </div>
    <div class="reappro__info-container info" v-if="next == true || recept == true || detail == true">
      <div class="info__number">
        <span>N° {{ item.sh_number }}</span> | <strong>{{ item.order_date | moment("D/MM/YYYY")}}</strong>
      </div>
      <div class="info__status">
        Statut : <u>{{ $t('order.statuses.'+item.status) }}</u>
      </div>
    </div>
    <input name="" value="" class="search__field" placeholder="Recherche" v-else-if="list != true && detail != true" @keyup="searchFilter()">
  </div>
</template>

<script>


export default {
  name: "ReapproHeader",
  props: [
    "next",
    "recept",
    "list",
    "detail",
    "item"
  ],
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  methods:{
    searchFilter(){
      let searched = event.target.value;
      this.$emit('searchReappro', searched);
    },
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: white;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    color: white;
  }

  .reappro__header{ background-color: $color4; padding: 65px 20px 20px 20px; width: 100%;
    .backlink{ margin-bottom: 5px; }
    .reappro__header-title-container{ display: flex; align-items: flex-end; }
    img{ width: 100px; margin-left: 35px; }
    span{ color: white; font-family: 'ClanFFBlack'; font-size: 25px; margin-top: 25px; text-transform: uppercase; flex: 1; text-align: right; }
    .search__field{ background-color: transparent; border: 1px solid white; font-family: 'ClanPro'; font-size: 14px; color: white; width: 100%; outline: none; height: 45px; line-height: 45px; padding: 0 20px; border-radius: 24px; margin-top: 20px; margin-top: 30px; }
    &--list{ padding-bottom: 0; }
    @media screen and (max-width: 420px){
      .reappro__header-title-container{
        span{ font-size: 22px; }
      }
    }
    @media screen and (max-width: 375px){
      .reappro__header-title-container{
        span{ font-size: 18px; }
      }
    }
    @media screen and (max-width: 350px){
      .reappro__header-title-container{
        span{ font-size: 16px; }
      }
    }
  }

  .info{ display: flex; flex-direction: column;
    &__number{ text-align: right; color: white;
      span{ font-family: 'ClanPro'; font-size: 15px; }
      strong{ font-family: 'ClanProBold'; font-weight: normal; font-size: 15px; }
    }
    &__status{ color: white; font-size: 12px; margin-top: 10px;
      u{ font-family: 'ClanProBold'; font-weight: normal; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproHeader.vue